import {
  COMPLETE_JOB,
  COMPLETE_JOB_FAILURE,
  COMPLETE_JOB_SUCCESS,
} from './action';

const initialState = {
  loading: false,
  data: [],
  error: '',
};

const postCompleteJobProviderReducer = (state = initialState, action) => {
  switch (action.type) {
    case COMPLETE_JOB:
      return { ...state, loading: true };
    case COMPLETE_JOB_SUCCESS:
      return { ...state, loading: false, data: action.payload, error: '' };
    case COMPLETE_JOB_FAILURE:
      return { ...state, loading: false, data: [], error: action.payload };
    default:
      return state;
  }
};

export default postCompleteJobProviderReducer;
